//import Account from './../../Resources/script.js'

// import { createNamespacedHelpers } from 'vuex'

// const { mapState,  mapGetters, mapActions} = createNamespacedHelpers('account')


//import AccountResources from '../../Template/script.js' //scripts
import service from "../../../../services/service";
import commonfunctions from "../../Resources/commonfunctions";
export default {
    name: 'AccountSellpoint',
    mixins: [commonfunctions],
    data () {
        return {
            has_sellpoints:{},
            sellpoint:{},
            categories:{},
            products:{},
        }
    },

    computed: {
        // look up in `account`
        // ...mapState({
        //   //sellpoint: state => state.sellpoint,
        //   //b: state => state.b
        // })
      },

    components: {
       
    },
     
    methods: {
       
        // ...mapGetters({
        //     sellpoint: 'getUserBusiness'
        // }),

        // // look up in `account`
        // ...mapActions([
        //     //'userBusinessCategories',
        //     'userBusinessProducts',
        // ]),

        setSellpointPage(){
            this.action_loading = true;
            let self = this;console.log(7988);
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    console.log(value);
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    console.log(988);console.log(self.sellpoint);
                    if((self.sellpoint == undefined)){
                        //no sellpoint set //check store
                        self.loadAccountBase();
                    }else{
                        //
                        self.setSellpoint();
                    }
                    //self.action_loading = false;
                    //self.setSellpintDetails();
                    //self.setSellpointMoreDetails();
                }else{
                    console.log(8099)
                    self.loadAccountBase();
                }
            });
            //console.log(22623); console.log(this.getUserBusiness)
            //this.okStore = {}
            //this.okStore = this.$store.getters['account/getUserBusiness'];
            // let self = this;
            // setTimeout(function(){ 
            //     self.okStore = self.$store.getters['account/getUserBusiness']; 
            // }, 100); //wait for 3sec 
            //this.sellpoint = this.$store.getters['account/getUserBusiness'];
            // let self = this;
            // setTimeout(function(){ 
            //     self.sellpoint = self.$store.getters['account/getUserBusiness']; 
            //     //
            //     if(Object.keys(self.sellpoint).length > 0){console.log(221)
            //         //get sellpoint details
            //         self.setSellpintDetails();
            //         self.setSellpointMoreDetails();
            //     }
            // }, 100); //wait for 3sec 
            
        },

        setSellpintDetails(){
            //dispatches
            this.$store.dispatch('account/setBusinessCategories');
            this.$store.dispatch('account/setBusinessProducts');
            //
            let self = this;
            setTimeout(function(){ 
                self.categories = self.$store.getters['account/getBusinessCategories'];
                self.products = self.$store.getters['account/getBusinessProducts'];
            }, 1000); //wait for 1sec
        },

        setCategory(data){
            this.$store.dispatch('account/setCategory',data);
            this.$router.push('/account/business/category');
        },
        
        setProduct(data){
            this.$store.dispatch('account/setProduct',data);
            this.$router.push('/account/business/product');
        },

        setSellpointMoreDetails(){
            this.getAppBusinessSubscription();
            this.getBusinessDeliveryOptions();
            this.getBusinessDiscountsAndCoupons();
        },

        setHeaderName(){
            if(this.$route.path == '/account/business/product'){
                this.header_name = 'Product';
            }else{
                this.header_name = this.getService.app_name
            }
            
        }
      
    },

    created: function(){
        this.setHeaderName();
        this.setSellpointPage();
        let self = this;
        //check if an active dynamic request was sent here 
        // localforage.getItem(self.getService.adr_db_name, function(err, value) { //quick with the callback version
        //     if(value != undefined) {console.log(5988);
        //         self.$router.push(value.link);
        //     }else {console.log(6988);
        //         //self.action_loading = false
        //         self.setSellpointPage();
        //     }
        // });
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Template/script.js